import React from 'react';
import * as PropTypes from 'prop-types';
import HeaderGeneralLanguagesItem from './HeaderGeneralLanguagesItem';
import languagePropTypes from '../../../../proptypes/language';

const HeaderGeneralLanguagesList = ({ languages }) =>
	languages.map((languageItem) => (
		<HeaderGeneralLanguagesItem
			{...languageItem}
			key={languageItem.languageCode}
		/>
	));

HeaderGeneralLanguagesList.propTypes = {
	languages: PropTypes.arrayOf(PropTypes.shape(languagePropTypes)),
};

HeaderGeneralLanguagesList.defaultProps = {
	languages: [],
};

export { HeaderGeneralLanguagesList };
